import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { UserDataChangesModel } from '../models/user-data-changes.model';
import { UserDataChangesEndpoint } from '../constants/user-data-changes-endpoint';

@Injectable({
  providedIn: 'root',
})
export class UserDataChangesListService {
  constructor(private http: WrapperHttpService) {}

  getUserDataChangesList(searchCriteria: { email: string }): Observable<UserDataChangesModel[]> {
    const url = `${API_URL}${UserDataChangesEndpoint.Base}?` + getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<UserDataChangesModel[]>(url);
  }
}
